import React from "react";
import NotRecord from "../../images/Clear-filter.svg";
import BillingNodata from "../../images/billing-nodata.svg";


export default function NoBillingPeriodSelect(props) {
  return (
    <div id="notfound">
      <div style={{ height: "400px" }} className="notfound">
        <div className="notfound-404">
          <img style={{ width: "60%" }} src={BillingNodata} />
          <p className="no-result-text">No billing statements found. Please select a new statement to get started.</p>
        </div>
      </div>
    </div>
  );
}
